module.exports = __webpack_public_path__ + "static/media/iconTarget2.b4cc5a10.svg";